// extracted by mini-css-extract-plugin
export var btnBlock = "main-module--btn-block--41a13";
export var mainBtn = "main-module--main-btn--d604f";